import { Minus } from "components/icons/generated";
import ButtonIcon from "ds/components/ButtonIcon";

import useAssistantPanelStore from "../useStore";
import useAssistantPanelAnalytics from "../../analytics/useAnalytics";
import useChatStore from "../../Chat/store/useStore";
import useIsAssistantPageMode from "../../hooks/useIsAssistantPageMode";

const AssistantPanelLayoutHeaderActions = () => {
  const chatId = useChatStore((state) => state.chat?.id);
  const isAssistantPageMode = useIsAssistantPageMode();

  const setIsOpen = useAssistantPanelStore((state) => state.setIsOpen);
  const { trackConversationDismissed } = useAssistantPanelAnalytics();

  if (isAssistantPageMode) {
    return null;
  }

  return (
    <ButtonIcon
      icon={Minus}
      onPress={() => {
        trackConversationDismissed(chatId !== undefined);
        setIsOpen(false);
      }}
      variant="ghost"
    >
      Minimize Assistant
    </ButtonIcon>
  );
};

export default AssistantPanelLayoutHeaderActions;
